import { z } from 'zod';

export const ConfirmResendCertificateFormSchema = z.object({
  email: z
    .string()
    .trim()
    .email({ message: 'กรุณากรอก Email ให้ถูกต้อง' })
    .regex(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/, { message: 'กรุณากรอก Email ให้ถูกต้อง' }),
});

export type ConfirmResendCertificateFormInput = z.infer<typeof ConfirmResendCertificateFormSchema>;
